import {pendoService} from '@/modules/common/services'
import ThryvTealiumScript from "@/modules/common/utils/thryvTealiumScript";
const userActivityPackage = 'https://d1e7vhqfrchhaw.cloudfront.net/pov/vendor-js/user_activity_package.js';
import Vue from 'vue';
import {datadogLogs} from '@datadog/browser-logs';
import store from '@/store/store';
import eventListenerService from '@/modules/common/services/eventListenerService';

const isPendoDenied = () => Vue.prototype.$hasFeature('pkg.bus.pendo.deny');

// build scripts only once
let firstRun = true

const set = (account, conditions = {}, data = {}) => {
  const isMobile = Vue.prototype.$isMobile() || Vue.prototype.$isMobileApp();
  const isTealiumEnabled = conditions.hasFeature('thryv_tealium_script')
  const hasDatadogLogs = Vue.prototype.$hasFeature('add_datadog_browser_logs');

  // Pendo logic refactored to use feature flag event
  function initializePendoIfAllowed() {
    eventListenerService.removeListener('featureFlagsLoaded', initializePendoIfAllowed);
    if (!isPendoDenied() && account.external_integrations.pendo.enabled && (conditions.isStar || !isMobile)) {
      let pendoAPIkey = (conditions?.isMobile || conditions?.isMobileApp)  ? account.external_integrations.pendo.mobile : account.external_integrations.pendo.desktop
      pendoService.buildPendo(pendoAPIkey)
      pendoService.initPendo(account, conditions?.isStar, conditions?.isMobile, data?.matterTerm, data?.numOfStaff, store.getters.isImpersonate)
    }
  }

  eventListenerService.addListener('featureFlagsLoaded', initializePendoIfAllowed);
  if (Vue.prototype.$featureFlagsLoaded()) {
    initializePendoIfAllowed();
  }

  if (firstRun) {
    if (isTealiumEnabled) {
      runTealium(account, data.numOfStaff);
    }
    if (hasDatadogLogs) {
      initDatadogBrowserLogs(window.vue_config.VUE_APP_ENV);
    }
    if (account.business.has_logrocket_script) runLogrocketScript(account)
  }

  if (conditions.hasFeature('session_timeout')) {
    addUrlScriptToWindow(userActivityPackage)
  }

  firstRun = false
}

function runLogrocketScript(account){
  let logrocket_event_method = account.brand.logrocket_script[0]
  let logrocket_src_script = account.brand.logrocket_script[1]
  let logrocket_script =  account.brand.logrocket_script[2]
  let data = {
    "%THRYV_ID%": account.business.uid,
    "%NAME%": account.staff.full_name.replace(/[^a-zA-Z0-9 ]/g, ""),
    "%STAFF_ID%": account.staff.uid,
    "%LOGIN_EMAIL%": account.staff.email
  }
  for (const property in data) {
    logrocket_script = logrocket_script.replace(property, data[property])
  }
  let method_element = document.createRange().createContextualFragment(logrocket_event_method)
  document.head.appendChild(method_element)
  let src_element = document.createRange().createContextualFragment(logrocket_src_script)
  document.head.appendChild(src_element)
  let element = document.createRange().createContextualFragment(logrocket_script)
  document.head.appendChild(element)
}

function runTealium(account, numberOfStaff){
  if(!!window.thryv_tealium){
    return
  }
  const tealiumScript = ThryvTealiumScript.getScriptAsString({
    businessData: account.business,
    staffData: account.staff,
    settingsData: account.settings,
    profileData: account,
    numberOfStaffs: numberOfStaff,
  })
  addScriptToWindow('thryv_tealium',tealiumScript)
}

const initDatadogBrowserLogs = (env) => {
  datadogLogs.init({
    clientToken: 'pub4260be43d9f008de18658de92dbbb038',
    site: 'datadoghq.com',
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ['error'],
    sessionSampleRate: 100,
    trackSessionAcrossSubdomains: true,
    usePartitionedCrossSiteSessionCookie: true,
    env,
  });
};

export default {
  set,
  addUrlScriptToWindow,
};

function addScriptToWindow(id, script){
  let element = document.createElement('script')
  element.innerHTML = script
  element.setAttribute('id',id)
  document.getElementsByTagName('head')[0].appendChild(element)
}

function addUrlScriptToWindow(url){
  let element = document.createElement('script')
  element.setAttribute('src', url)
  document.getElementsByTagName('head')[0].appendChild(element)
  return element
}
